import { createSelector } from '@ngrx/store';
import { selectFilterState } from '../filter.selectors';
import { FilterState, RoomCountFilterState } from '@immosky/types';

export const selectRoomCountFilterState = createSelector(
  selectFilterState,
  (state: FilterState) => state.roomCount
);

export const selectRoomCountFilterOptions = createSelector(
  selectRoomCountFilterState,
  (state: RoomCountFilterState) => state.options
);
